import Button from "@mostrans/web-components/components/base/Button";
import { Typography } from "@mui/material";
import React from "react";
import ModalPdfPreassesment from "./modals/ModalPdfPreassesment";

function PreAssesmentAdmin(props) {
  const { dataCandidateByID } = props;

  // const createPdfHtml = () => {
  //   const stringHtml = renderToString(<PdfPreAssesment />);
  //   const pdf = new jsPDF('p', 'mm', 'a4');;
  //   pdf.html(stringHtml, {
  //     callback: function (pdf) {
  //       pdf.save('preassesment.pdf');
  //     },
  //   });
  // }

  return (
    <React.Fragment>
      <div className="form-row">
        <div className="col-md-12" style={{ display: "flex", justifyContent: "flex-end" }}>
          {
            dataCandidateByID?.PreAssessment ? (
              <ModalPdfPreassesment dataCandidateByID={dataCandidateByID} />
            ) : null
          }
        </div>
      </div>
      {dataCandidateByID?.PreAssessment ? (
        <React.Fragment>
          <div className="form-row mt-2">
            <div className="col-md-10">
              <Typography id="soal-1" align="justify">
                1. Ceritakanlah kejadian atau masalah yang pernah anda alami di
                dalam pekerjaan (boleh di tempat kerja saat ini atau di tempat
                kerja sebelumnya) yang dampak atau hasilnya Anda rasakan sebagai
                sukses besar atau kepuasan bagi diri Anda. (Apabila anda
                freshgraduate maka boleh memberikan pengalaman selama masa
                pendidikan).
              </Typography>
              <Typography sx={{ fontWeight: "500" }}>
                Answer: <br />
                {dataCandidateByID.PreAssessment.answer1
                  ? dataCandidateByID?.PreAssessment.answer1
                  : "-"}
              </Typography>
            </div>
            <div className="col-md-10 mt-2">
              <Typography id="soal-2" align="justify">
                2. Ceritakanlah kejadian atau masalah yang pernah Anda alami di
                dalam pekerjaan (boleh di tempat kerja saat ini atau di tempat
                kerja sebelumnya) yang dampak atau hasilnya Anda rasakan sebagai
                suatu kegagalan besar atau ketidakpuasan bagi Anda.
              </Typography>
              <Typography sx={{ fontWeight: "500" }}>
                Answer: <br />
                {dataCandidateByID.PreAssessment.answer2
                  ? dataCandidateByID?.PreAssessment.answer2
                  : "-"}
              </Typography>
            </div>
            <div className="col-md-10 mt-2">
              <Typography id="soal-3" align="justify">
                3. Ceritakan secara terperinci improvement/perbaikan yang telah
                Anda lakukan selama ini, baik di tempat kerja saat ini atau di
                tempat kerja sebelumnya.
              </Typography>
              <Typography sx={{ fontWeight: "500" }}>
                Answer: <br />
                {dataCandidateByID.PreAssessment.answer3
                  ? dataCandidateByID?.PreAssessment.answer3
                  : "-"}
              </Typography>
            </div>
            <div className="col-md-10 mt-2">
              <Typography id="soal-4" align="justify">
                4. Apakah Anda pernah / sedang diproses di Kalbe Group?
              </Typography>
              <Typography sx={{ fontWeight: "500" }}>
                Answer: <br />
                {dataCandidateByID.PreAssessment?.answer4 === true
                  ? "YA"
                  : "TIDAK"}
              </Typography>
            </div>
            {
              dataCandidateByID?.PreAssessment?.answer4 === true ? (
                <div className="col-md-10 mt-2">
                  <Typography id="soal-4" align="justify">
                    5. Apabila anda pernah/sedang di proses di Kalbe Group, silahkan
                    sebutkan company-nya.
                  </Typography>
                  <Typography sx={{ fontWeight: "500" }}>
                    Answer: <br />
                    {dataCandidateByID.PreAssessment?.answer5
                      ? dataCandidateByID.PreAssessment?.answer5
                      : "Tidak ada"}
                  </Typography>
                </div>
              ) : null
            }
          </div>
        </React.Fragment>
      ) : (
        <div className="form-row mt-2">
          <div className="col-md-6">
            <Typography>Pre Assesment Result Not Found</Typography>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default PreAssesmentAdmin;
